import { render, staticRenderFns } from "./ShapesPage.vue?vue&type=template&id=6a7e48cc"
import script from "./ShapesPage.vue?vue&type=script&lang=js"
export * from "./ShapesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports